var _metadata, _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg5249",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata5253"
  })), _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc5224"
  }, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs5239"
  }, /*#__PURE__*/React.createElement("filter", {
    x: "-23.9%",
    y: "-17.9%",
    width: "147.8%",
    height: "135.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1",
    id: "feOffset5226"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    id: "feGaussianBlur5228"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.145098039   0 0 0 0 0.149019608   0 0 0 0 0.164705882  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    id: "feColorMatrix5230"
  }), /*#__PURE__*/React.createElement("feMerge", {
    id: "feMerge5236"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1",
    id: "feMergeNode5232"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic",
    id: "feMergeNode5234"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "matrix(3,0,0,3,-73.000001,-71.019)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "slozka-list-190415",
    transform: "translate(-313,-349)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ovladani",
    transform: "translate(144,344)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "plus-copy-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "007-share",
    transform: "translate(196,31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 18.505208,0 h -4.933034 c -0.273295,0 -0.494792,0.22149656 -0.494792,0.49479167 0,0.27329511 0.221497,0.49479166 0.494792,0.49479166 h 3.746114 L 7.6940104,10.706055 c -0.1845805,0.195404 -0.1795552,0.502136 0.01121,0.691355 0.1907654,0.189219 0.4976909,0.191345 0.6913554,0.0052 L 18.010417,1.6971741 v 3.7306518 c 0,0.2732951 0.221496,0.4947917 0.494791,0.4947917 C 18.778503,5.9226176 19,5.701121 19,5.4278259 V 0.49479167 C 19,0.22149656 18.778503,0 18.505208,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16.038015,10.612895 c -0.273295,0 -0.494792,0.221496 -0.494792,0.494791 v 5.418356 c -9.66e-4,0.819498 -0.664876,1.483408 -1.484375,1.484375 H 2.4739583 C 1.6544596,18.00945 0.99054971,17.34554 0.98958333,16.526042 V 4.9411519 C 0.99054971,4.1216532 1.6544596,3.4577433 2.4739583,3.4567769 h 5.4183553 c 0.2732951,0 0.4947917,-0.2214965 0.4947917,-0.4947916 0,-0.2732951 -0.2214966,-0.4947917 -0.4947917,-0.4947917 H 2.4739583 C 1.108256,2.4687398 0.00154622,3.5754496 0,4.9411519 V 16.526042 C 0.00154622,17.891744 1.108256,18.998454 2.4739583,19 H 14.058848 c 1.365702,-0.0015 2.472412,-1.108256 2.473958,-2.473958 v -5.418356 c 0,-0.273295 -0.221496,-0.494791 -0.494791,-0.494791 z",
    id: "path5242"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/ShareIcon.57033064f6431215da788e9bc1c4696b.svg";
export { ForwardRef as ReactComponent };